<template>
  <div class="col-12 relative grey-bg full-height flex flex-column">
    <template v-if="route.matched.length === 3 && !route.meta.breadcrumb">
      <CategoryHeader :title="route.meta.title" :icon="route.meta.icon" />
    </template>

    <div v-if="loading" class="relative full-height flex items-center justify-center pb5">
      <div class="center">
        <div class="list-loader-blue"></div>
      </div>
    </div>

    <router-view v-else class="p3" />
  </div>
</template>

<script>
import { onBeforeMount, ref, provide, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

import {
  add,
  startOfDay,
  endOfWeek,
  format
} from 'date-fns';
import { getScheduledReservations } from '@/mixins/requests';

import CategoryHeader from '@/components/common/CategoryHeader';

export default {
  components: { CategoryHeader },
  setup () {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const loading = computed(() => store.state.loadingContent);
    const workspace = computed(() => store.state.siteInfo.workspace);

    const participants = ref([]);

    onBeforeMount(async () => {
      store.commit('setLoadingContent', false);
      store.commit('setLoading', true);
      store.commit('resetCalendarDays');

      await getScheduledReservations({ workspace: workspace.value }).then(res => {
        participants.value = res;
      }).catch(err => {
        console.log('err: ', err);
        participants.value = [];
      }).finally(() => {
        store.commit('setLoading', false);
      });
    });

    provide('participants', participants);
    return {
      router,
      route,
      loading,
      store
    };
  }
};

</script>
